const getItem = (key: any) => {
  return sessionStorage.getItem(key);
};
const setItem = (key: any, value: any) => {
  return sessionStorage.setItem(key, value);
};
const clearSessionStorage = () => {
  sessionStorage.clear();
};
export { getItem, clearSessionStorage, setItem };
